import React from 'react';
import ElivaraListicle from './pages/ElivaraListicle';
export function App() {
  return <ElivaraListicle data-id="element-0" />;
}